import { FetchPhoneNumbersRequestTypes } from '../actions/PhoneNumbersActions';
// This is the default NorthAm fallback sales number. NOT Invoca
const initialState = {
  bundle: '1 857 829 5060',
  'cms-footer': '1 857 829 5060',
  'cms-middle': '1 857 829 5060',
  'contact-sales-page': '1 857 829 5060',
  'crm-middle': '1 857 829 5060',
  'crmsuite-footer': '1 857 829 5060',
  'crmsuite-middle': '1 857 829 5060',
  'marketing-footer': '1 857 829 5060',
  'marketing-middle': '1 857 829 5060',
  'operations-footer': '1 857 829 5060',
  'operations-middle': '1 857 829 5060',
  'sales-footer': '1 857 829 5060',
  'sales-middle': '1 857 829 5060',
  'service-footer': '1 857 829 5060',
  'service-middle': '1 857 829 5060'
};

const PhoneNumbers = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchPhoneNumbersRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data;
      }

    default:
      return state;
  }
};

export default PhoneNumbers;